import './public-path'
import Vue from 'vue'
import i18n from '@/plugins/i18n'
import './plugins/axios'
import App from './App.vue'
import Router from 'vue-router'
import routes from '@/routes'
import store from './store'
import './api'
import './plugins/sweet'
import './plugins/element'
import './theme/index.scss'
import './components'
import './plugins/sso'
import DeviceDetector from './plugins/device-detector';
Vue.use(DeviceDetector);

Vue.config.productionTip = false

if (window.top === window.self) {
  if (process.env.VUE_APP_LOGIN_WAY === '1') {
    // 域登录时用于子Iframe调用，通知登录状态变化
    window.LOGIN = {
      changeState() {
        // 改变登录状态
        store.commit('global/CHANGE_LOADING', false)
      },
      loginSuccess() {
        // 用于子Iframe登录成功之后调用 达到通信作用
        Vue.sso.signIn()
      }
    }
  }
}

// 用于保存vue实例
let instance = null

// 独立运行时，直接挂载应用
if (!window.__POWERED_BY_QIANKUN__) {
  render()
}

// 渲染函数（两种情况：主应用生命周期钩子中运行 / 微应用单独启动时运行）
function render(props = {}) {
  // 如果是微前端模式，会传入container（container 是主应用生成的，用于装载子应用的 div 元素）
  const { container } = props
  const router = new Router({
    mode: 'history',
    base: props.name || '/',
    routes
  })
  Vue.use(Router)

  new Vue({
    router,
    store,
    i18n,
    render: (h) => {
      return h(App)
    }
  }).$mount(container ? container.querySelector('#app') : '#app')
}

// 安装微前端相关
function installMicroAppsInfo(props) {
  // 获取在主应用中注册的名称
  Vue.prototype.$registerMicroAppName = props.name
  // 获取路由前缀
  Vue.prototype.$routerPathSuffix = props.routerPathSuffix
  // 获取url前缀
  Vue.prototype.$urlPathSuffix = props.urlPathSuffix
  // 获取主应用session信息
  Vue.prototype.$mainFramworkSession = props.sessionId
  // 获取主应用微前端接入类型的路由前缀
  Vue.prototype.$mainType = props.mainType === 'portal' ? '/introduction/template' : ''
  // 获取控制台的url域名
  Vue.prototype.$consoleUrl = props.consoleUrl
  // 全局监听处理函数
  props.onGlobalStateChange &&
    props.onGlobalStateChange(
      (value, prev) => {
        console.log(`[onGlobalStateChange - ${props.name}]:`, value, prev)
        // 获取systemEnv在发送请求时传给后端，用于在微应用中切换环境
        Vue.prototype.$systemEnv = value.env
        // 获取空间id
        Vue.prototype.$spaceId = value.spaceId
        // 获取应用id
        Vue.prototype.$appId = value.appId
        // 获取主应用ssoAccessToken
        Vue.prototype.$ssoAccessToken = value.ssoAccessToken
      }, true
    )

  // 消息发送函数，放入vue原型中，方便全局调用
  Vue.prototype.$setGlobalState = props.setGlobalState

  // Vue.sso.signIn()
}

// 微前端模式下的钩子导出
/**
 * bootstrap 只会在微应用初始化的时候调用一次，下次微应用重新进入时会直接调用 mount 钩子，不会再重复触发 bootstrap。
 * 通常我们可以在这里做一些全局变量的初始化，比如不会在 unmount 阶段被销毁的应用级别的缓存等。
 */
export async function bootstrap() {
  // ！！！必须增加try catch处理，防止未知异常
  try {
    console.log('[gap-web-it-potal] vue app bootstraped')
  } catch (e) { }
}

// 微应用挂载
// 应用每次进入都会调用 mount 方法，通常我们在这里触发应用的渲染方法
export async function mount(props) {
  // ！！！必须增加try catch处理，防止未知异常
  try {
    console.log('[gap-web-it-potal] props from main framework', props)
    // 安装
    installMicroAppsInfo(props)
    // 看板渲染
    render(props)
    Vue.sso.signIn()
  } catch (e) { }
}

// 微应用卸载
// 应用每次 切出/卸载 会调用的方法，通常在这里我们会卸载微应用的应用实例
export async function unmount() {
  // ！！！必须增加try catch处理，防止未知异常
  try {
    if (instance) {
      instance.$destroy()
      instance.$el.innerHTML = ''
      instance = null
    }
  } catch (e) { }
}
